export const statusOptions = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];

export const userTypeOptions = [
  {
    label: "Super Admin",
    value: "super_admin",
  },
  {
    label: "User",
    value: "user",
  },
];
